import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import Actions from './ActionsComponent';

const ConfirmModal = (props) => {
  const {
    bodyText,
    customActions,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    actionFilter,
  } = props;

  const actions =
    customActions ||
    [
      { label: cancelText, onClick: onCancel, color: 'primary' },
      {
        label: confirmText,
        onClick: onConfirm,
        color: 'secondary',
      },
    ].filter(actionFilter);

  return (
    <>
      <Typography variant="body1" component="div">
        {bodyText}
      </Typography>
      <Actions actions={actions} />
    </>
  );
};

ConfirmModal.defaultProps = {
  bodyText: 'Are you sure you want to do this?',
  customActions: null,
  confirmText: "Yes, I'm sure",
  cancelText: 'No',
  actionFilter: (action) => action,
};

ConfirmModal.propTypes = {
  bodyText: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
  ]),
  customActions: PropTypes.instanceOf(Array),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  actionFilter: PropTypes.func,
};

export default ConfirmModal;
